import { ReactElement } from 'react';
import cn from 'classnames';
import { MovieDetails, Skeleton, Text } from '@intigral/shared';
import styles from './cast-and-crew-card.module.sass';

interface ICastAndCrewCard extends React.HTMLAttributes<HTMLDivElement> {
    DetailsButton: (children: ReactElement) => any;
    photoSrc: string;
    title: string;
    position?: string;
    isLoading?: boolean;
    isDetailsOverlay?: boolean;
}

export const CastAndCrewCard = ({
    DetailsButton,
    photoSrc,
    title,
    position,
    isLoading,
    isDetailsOverlay = false,
    ...props
}: ICastAndCrewCard) => {
    if (isLoading) {
        return (
            <div className={cn(styles.card, styles.skeleton)}>
                <Skeleton />
            </div>
        );
    }

    return (
        <div className={styles.card} {...props}>
            {DetailsButton(
                <>
                    <div className={styles.photo}>
                        <img src={photoSrc} alt={title} />
                    </div>
                    <div className={styles.info}>
                        <Text as="span" variant="text5" color="white" margin="0" size={{ md: '16' }} alignment="start">
                            {title}
                        </Text>
                        {isDetailsOverlay && position && (
                            <Text
                                as="span"
                                variant="text5"
                                margin="0"
                                color="gray"
                                size={{ md: '14' }}
                                alignment="start"
                            >
                                {position}
                            </Text>
                        )}
                    </div>
                </>
            )}
        </div>
    );
};
